import { render } from "./WarningMessage.vue?vue&type=template&id=51f77984&scoped=true"
import script from "./WarningMessage.vue?vue&type=script&lang=js"
export * from "./WarningMessage.vue?vue&type=script&lang=js"

import "./WarningMessage.vue?vue&type=style&index=0&id=51f77984&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f77984"]])

export default __exports__